
import * as React from 'react'

const SvgDate = () => (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.66602 1.66663V4.16663" stroke="#98A2B3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.334 1.66663V4.16663" stroke="#98A2B3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.91602 7.57495H17.0827" stroke="#98A2B3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.5 7.08329V14.1666C17.5 16.6666 16.25 18.3333 13.3333 18.3333H6.66667C3.75 18.3333 2.5 16.6666 2.5 14.1666V7.08329C2.5 4.58329 3.75 2.91663 6.66667 2.91663H13.3333C16.25 2.91663 17.5 4.58329 17.5 7.08329Z" stroke="#98A2B3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.0781 11.4167H13.0856" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.0781 13.9167H13.0856" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.99607 11.4167H10.0036" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.99607 13.9167H10.0036" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.91209 11.4167H6.91957" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.91209 13.9167H6.91957" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
)

export default SvgDate
